import * as Yup from 'yup';
import validation from 'modules/v2/common/validationSchema';

const ValidationSchema = Yup.object().shape({
  firstName: validation.firstName,
  lastName: validation.lastName,
  email: validation.email,
  phone: validation.phoneNumber,
  addressLine1: validation.address1,
  pincode: validation.pincode,
  city: validation.city,
  country: validation.country,
  state: validation.state,
  segments: validation.campaignSegments,
});

export default ValidationSchema;
